import React from 'react';
import './ChatList.css';

export default function ChatList({ chats, activeChatId, onSelect, currentUserId }) {
    if (!chats.length) {
        return <div className="chat-list-empty">Нет диалогов</div>;
    }

    return (
        <div className="chat-list">
            {chats.map(chat => {
                const otherParticipant = chat.participants.find(p => p.userId !== currentUserId);
                const name = chat.isGroup ? chat.name : otherParticipant?.userName;
                const avatar = otherParticipant?.avatarUrl;
                const lastMsg = chat.lastMessage;
                const isActive = chat.id === activeChatId;

                return (
                    <div
                        key={chat.id}
                        className={`chat-list-item ${isActive ? 'active' : ''}`}
                        onClick={() => onSelect(chat)}
                    >
                        <div className="chat-list-avatar">
                            {avatar
                                ? <img src={avatar} alt={name} />
                                : <div className="chat-list-avatar-placeholder">{name?.[0]?.toUpperCase()}</div>
                            }
                        </div>
                        <div className="chat-list-info">
                            <div className="chat-list-name">{name || 'Неизвестный'}</div>
                            {lastMsg && (
                                <div className="chat-list-preview">
                                    {lastMsg.isDeleted ? 'Сообщение удалено' : lastMsg.content}
                                </div>
                            )}
                        </div>
                        <div className="chat-list-meta">
                            {lastMsg && (
                                <span className="chat-list-time">
                                    {formatTime(lastMsg.sentAt)}
                                </span>
                            )}
                            {chat.unreadCount > 0 && (
                                <span className="chat-list-badge">{chat.unreadCount}</span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

function formatTime(isoString) {
    const date = new Date(isoString);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    return isToday
        ? date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
        : date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
}
